import script from "./DashboardPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardPanel.vue?vue&type=script&setup=true&lang=ts"

import "@/components/dashboard/DashboardPanel.css?vue&type=style&index=0&id=555896f2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555896f2"]])

export default __exports__